export * from './add-document.component';
